var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Box, Link, Stack, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import debounce from 'lodash/debounce';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Autocomplete, ConfirmDialog, FallbackComponent, NativeNumberInput, NumberInput, UnControlledFormField } from '../../common';
import { OTHER_CURRENCY_ID, isCurrencySupported, useCurrencySymbol, useRollupAvailableCurrencies, useRollupCurrencyOptions, withCurrentCurrencyOption } from '../../hooks';
import { CopyFromLocationDropdown } from '../common/CopyFromLocationDropdown';
import { LocationListPanel } from '../common/LocationListPanel';
import { StepContentPanel } from '../common/StepContentPanel';
import { WizardTable } from '../common/WizardTable';
import { OrgConfigStepContainer } from '../common/stepContainer';
import { usePersistingLocationSelect } from '../common/usePersistingLocationSelect';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { useLocationsAPI } from '../selectors';
import { LocationRoleType, ROLE_TYPE_T_KEYS } from '../staffing/selectors';
import { AddCustomCurrencyDialog } from './AddCustomCurrencyDialog';
import { CurrencyConversionModal } from './CurrencyConversionModal';
import { saveLocationFinancials, saveOrgFinancials, useCopyFinancialsFromAPI, useFinancialsStatusAPI, useLocationFinancialsAPI, useOrgFinancialsAPI, useOrgFinancialsProviderRatesAPI } from './selectors';
var toNumberOrNull = function (v) {
  var trimmed = v.trim();
  if (!trimmed) return null;
  var n = Number.parseFloat(trimmed);
  return Number.isNaN(n) ? null : n;
};
var toBaseline = function (form) {
  return {
    currencyCode: form.currencyCode,
    overtimePercent: form.overtimePercent,
    premiumMultiplier: form.premiumMultiplier,
    roles: form.roles.map(function (r) {
      return __assign({}, r);
    })
  };
};
var baselinesEqual = function (a, b) {
  if (a.currencyCode !== b.currencyCode || a.overtimePercent !== b.overtimePercent || a.premiumMultiplier !== b.premiumMultiplier) {
    return false;
  }
  if (a.roles.length !== b.roles.length) return false;
  var byRole = new Map(b.roles.map(function (r) {
    return [r.roleName, r];
  }));
  return a.roles.every(function (r) {
    var o = byRole.get(r.roleName);
    return r.wageType === (o === null || o === void 0 ? void 0 : o.wageType) && r.amount === (o === null || o === void 0 ? void 0 : o.amount) && r.loadFactor === (o === null || o === void 0 ? void 0 : o.loadFactor);
  });
};
/** Any field filled counts as "started"; complete rows need wage type and amount >= 1. */
var hasIncompleteWageRow = function (form) {
  return form.roles.some(function (r) {
    var _a;
    var hasWageType = Boolean(r.wageType);
    var hasAmount = ((_a = toNumberOrNull(r.amount)) !== null && _a !== void 0 ? _a : 0) >= 1;
    var hasLoad = toNumberOrNull(r.loadFactor) !== null;
    if (!hasWageType && !hasAmount && !hasLoad) return false;
    if (hasWageType && !hasAmount) return true;
    if (!hasWageType && (hasAmount || hasLoad)) return true;
    return false;
  });
};
var isRoleRowComplete = function (r) {
  var _a;
  return Boolean(r.wageType) && ((_a = toNumberOrNull(r.amount)) !== null && _a !== void 0 ? _a : 0) >= 1;
};
var isRowStarted = function (r) {
  var hasWageType = Boolean(r.wageType);
  var hasAmount = toNumberOrNull(r.amount) !== null;
  var hasLoad = toNumberOrNull(r.loadFactor) !== null;
  return hasWageType || hasAmount || hasLoad;
};
var getStartedRowFieldErrors = function (r, showFieldErrors) {
  var _a;
  if (!showFieldErrors || !isRowStarted(r) || isRoleRowComplete(r)) {
    return {
      wageType: false,
      amount: false
    };
  }
  return {
    wageType: !r.wageType,
    amount: ((_a = toNumberOrNull(r.amount)) !== null && _a !== void 0 ? _a : 0) < 1
  };
};
var buildSaveableLocationPayload = function (form) {
  return {
    currencyCode: form.currencyCode ? form.currencyCode : null,
    overtimePercent: toNumberOrNull(form.overtimePercent),
    premiumMultiplier: toNumberOrNull(form.premiumMultiplier),
    wages: form.roles.filter(isRoleRowComplete).map(function (r) {
      return {
        roleName: r.roleName,
        wageType: r.wageType,
        amount: toNumberOrNull(r.amount),
        loadFactor: toNumberOrNull(r.loadFactor)
      };
    })
  };
};
var planLocationFinancialSave = function (form, locationId, baselineById) {
  var _a;
  var baseline = (_a = baselineById[locationId]) !== null && _a !== void 0 ? _a : null;
  var payload = buildSaveableLocationPayload(form);
  var nextBl = toBaseline(form);
  if (baseline !== null && baselinesEqual(nextBl, baseline) && payload.wages.length === 0) {
    return {
      kind: 'draft'
    };
  }
  return {
    kind: 'save',
    payload: payload
  };
};
var updateRoleAtIndex = function (form, index, patch) {
  return __assign(__assign({}, form), {
    roles: form.roles.map(function (row, i) {
      return i === index ? __assign(__assign({}, row), patch) : row;
    }),
    isDirty: true
  });
};
function persistDirtyOrgFormSnapshot(configVersionId, orgF) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, saveOrgFinancials(configVersionId, {
            rollupCurrency: orgF.rollupCurrency,
            rates: orgF.rates.map(function (r) {
              return {
                currencyCode: r.currencyCode,
                corporateOverrideRate: r.corporateOverrideRate === '' ? null : r.corporateOverrideRate
              };
            })
          })];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}
function clearLocationDraftDirtyIfUnchanged(form, id, baselineById, setFormMap) {
  var baseline = baselineById[id];
  if (!baseline || !baselinesEqual(toBaseline(form), baseline)) return;
  setFormMap(function (prev) {
    var _a;
    var cur = prev[id];
    if (!cur) return prev;
    return __assign(__assign({}, prev), (_a = {}, _a[id] = __assign(__assign({}, cur), {
      isDirty: false
    }), _a));
  });
}
function persistDirtyLocationSnapshot(id, form, baselineById, setFormMap) {
  return __awaiter(this, void 0, void 0, function () {
    var plan;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          plan = planLocationFinancialSave(form, id, baselineById);
          if (plan.kind === 'invalid') {
            return [2 /*return*/, {
              ok: false
            }];
          }
          if (plan.kind === 'draft') {
            clearLocationDraftDirtyIfUnchanged(form, id, baselineById, setFormMap);
            return [2 /*return*/, {
              ok: true,
              saved: false
            }];
          }
          return [4 /*yield*/, saveLocationFinancials(id, plan.payload)];
        case 1:
          _a.sent();
          baselineById[id] = toBaseline(__assign(__assign({}, form), {
            isDirty: false
          }));
          setFormMap(function (prev) {
            var _a;
            var cur = prev[id];
            if (!cur) return prev;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = __assign(__assign({}, cur), {
              isDirty: false
            }), _a));
          });
          return [2 /*return*/, {
            ok: true,
            saved: true
          }];
      }
    });
  });
}
function mergeConversionSaveRowsIntoOrgForm(prev, rows) {
  if (!prev) return prev;
  var nextRates = prev.rates.map(function (r) {
    var match = rows.find(function (x) {
      return x.currencyCode === r.currencyCode;
    });
    return match ? __assign(__assign({}, r), {
      corporateOverrideRate: match.corporateOverrideRate
    }) : r;
  });
  return __assign(__assign({}, prev), {
    rates: nextRates,
    isDirty: true
  });
}
function mergeCustomCurrencyIntoOrgForm(prev, currencyCode, corporateOverrideRate) {
  if (!prev) return prev;
  var exists = prev.rates.some(function (r) {
    return r.currencyCode === currencyCode;
  });
  var nextRates = exists ? prev.rates.map(function (r) {
    return r.currencyCode === currencyCode ? __assign(__assign({}, r), {
      corporateOverrideRate: corporateOverrideRate
    }) : r;
  }) : __spreadArray(__spreadArray([], prev.rates, true), [{
    currencyCode: currencyCode,
    corporateOverrideRate: corporateOverrideRate,
    lastUpdated: null,
    provenance: null,
    providerName: null,
    providerTimestamp: null
  }], false);
  return __assign(__assign({}, prev), {
    rates: nextRates,
    isDirty: true
  });
}
var mapOrgToForm = function (data) {
  var _a, _b;
  return {
    rollupCurrency: (_a = data.rollupCurrency) !== null && _a !== void 0 ? _a : 'USD',
    rates: ((_b = data.rates) !== null && _b !== void 0 ? _b : []).map(function (r) {
      var _a, _b, _c, _d, _e;
      return {
        currencyCode: r.currencyCode,
        corporateOverrideRate: (_a = r.corporateOverrideRate) !== null && _a !== void 0 ? _a : '',
        lastUpdated: (_b = r.lastUpdated) !== null && _b !== void 0 ? _b : null,
        provenance: (_c = r.provenance) !== null && _c !== void 0 ? _c : null,
        providerName: (_d = r.providerName) !== null && _d !== void 0 ? _d : null,
        providerTimestamp: (_e = r.providerTimestamp) !== null && _e !== void 0 ? _e : null
      };
    }),
    isDirty: false
  };
};
var wageTypeFromApi = function (raw) {
  if (raw === 'hourly') return 'hourly';
  return 'annual_salary';
};
var mapLocationToForm = function (data) {
  var _a, _b, _c, _d;
  return {
    currencyCode: (_a = data.currencyCode) !== null && _a !== void 0 ? _a : 'USD',
    overtimePercent: (_b = data.overtimePercent) !== null && _b !== void 0 ? _b : '',
    premiumMultiplier: (_c = data.premiumMultiplier) !== null && _c !== void 0 ? _c : '',
    roles: ((_d = data.roles) !== null && _d !== void 0 ? _d : []).map(function (r) {
      var _a, _b;
      return {
        roleName: r.roleName,
        roleType: r.roleType,
        wageType: wageTypeFromApi(r.wageType),
        amount: (_a = r.amount) !== null && _a !== void 0 ? _a : '',
        loadFactor: (_b = r.loadFactor) !== null && _b !== void 0 ? _b : ''
      };
    }),
    isDirty: false
  };
};
function FinancialsRoleRow(_a) {
  var row = _a.row,
    rowIndex = _a.rowIndex,
    getRoleDisplayName = _a.getRoleDisplayName,
    wageTypeHourlyLabel = _a.wageTypeHourlyLabel,
    wageTypeAnnualLabel = _a.wageTypeAnnualLabel,
    wageTypeError = _a.wageTypeError,
    amountError = _a.amountError,
    onWageTypeChange = _a.onWageTypeChange,
    onAmountChange = _a.onAmountChange,
    onLoadFactorChange = _a.onLoadFactorChange,
    disabled = _a.disabled,
    currencyCode = _a.currencyCode;
  var wageTypeOpts = useMemo(function () {
    return [{
      id: 'hourly',
      name: wageTypeHourlyLabel
    }, {
      id: 'annual_salary',
      name: wageTypeAnnualLabel
    }];
  }, [wageTypeHourlyLabel, wageTypeAnnualLabel]);
  var _b = useCurrencySymbol(currencyCode),
    currencySymbol = _b.currencySymbol,
    prefix = _b.prefix,
    suffix = _b.suffix;
  return _jsxs(TableRow, {
    children: [_jsx(TableCell, __assign({
      sx: {
        minWidth: 180
      }
    }, {
      children: getRoleDisplayName(row)
    })), _jsx(TableCell, __assign({
      sx: {
        minWidth: 180
      }
    }, {
      children: _jsx(Autocomplete, {
        size: "small",
        fullWidth: true,
        error: wageTypeError,
        options: wageTypeOpts,
        value: row.wageType,
        getOptionValue: function (o) {
          return o.id;
        },
        getOptionLabel: function (o) {
          return o.name;
        },
        isOptionEqualToValue: function (o, v) {
          return o.id === v.id;
        },
        placeholder: "",
        onChange: function (v) {
          if (v) onWageTypeChange(rowIndex, v);
        },
        disabled: disabled
      })
    })), _jsx(TableCell, __assign({
      sx: {
        minWidth: 160
      }
    }, {
      children: _jsx(NativeNumberInput, {
        min: 1,
        max: 10000000,
        decimal: 2,
        error: amountError,
        value: row.amount,
        disabled: disabled,
        onChange: function (v) {
          return onAmountChange(rowIndex, v);
        },
        placeholder: currencySymbol,
        prefix: prefix,
        suffix: suffix
      })
    })), _jsx(TableCell, __assign({
      sx: {
        minWidth: 160
      }
    }, {
      children: _jsx(NumberInput, {
        fullWidth: true,
        min: 0,
        max: 100,
        decimal: 2,
        value: row.loadFactor,
        disabled: disabled,
        onChange: function (v) {
          return onLoadFactorChange(rowIndex, v);
        },
        inputProps: {
          style: {
            textAlign: 'center'
          }
        },
        suffix: '%'
      })
    }))]
  });
}
export var FinancialsStep = function () {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'financials'
  }).t;
  var tStaffing = useTranslation('orgConfig', {
    keyPrefix: 'staffing'
  }).t;
  var _p = useContext(OrgConfigWizardContext),
    configVersionId = _p.configVersionId,
    setBeforeNext = _p.setBeforeNext,
    selectedLocationId = _p.selectedLocationId,
    setSelectedLocationId = _p.setSelectedLocationId,
    _q = _p.isReadOnly,
    isReadOnly = _q === void 0 ? false : _q;
  var getRoleDisplayName = useCallback(function (row) {
    if (row.roleName === 'Agent') {
      return String(t('table.agent', {
        defaultValue: 'Agent'
      }));
    }
    if (row.roleType === LocationRoleType.Custom) {
      return row.roleName;
    }
    var tKey = ROLE_TYPE_T_KEYS[row.roleType];
    if (tKey) {
      return String(tStaffing(tKey, {
        defaultValue: row.roleName
      }));
    }
    return row.roleName;
  }, [t, tStaffing]);
  var _r = useState(null),
    headerRightEl = _r[0],
    setHeaderRightEl = _r[1];
  useEffect(function () {
    setHeaderRightEl(document.getElementById('org-config-financials-header-top-right'));
  }, []);
  var _s = useState(false),
    conversionOpen = _s[0],
    setConversionOpen = _s[1];
  var _t = useState(null),
    pendingRollup = _t[0],
    setPendingRollup = _t[1];
  var _u = useLocationsAPI(configVersionId),
    locationsData = _u[0],
    fetchLocations = _u[1];
  var allLocations = useMemo(function () {
    var _a, _b;
    return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
  }, [locationsData.data]);
  var selectedLocation = useMemo(function () {
    var _a;
    return (_a = allLocations.find(function (l) {
      return l.id === selectedLocationId;
    })) !== null && _a !== void 0 ? _a : null;
  }, [allLocations, selectedLocationId]);
  var _v = useOrgFinancialsAPI(configVersionId),
    orgData = _v[0],
    fetchOrgFinancials = _v[1];
  var _w = useOrgFinancialsProviderRatesAPI(configVersionId),
    providerRatesData = _w[0],
    fetchProviderRates = _w[1];
  var _x = useState(null),
    orgForm = _x[0],
    setOrgForm = _x[1];
  var rollupForAvailable = ((_c = (_a = orgForm === null || orgForm === void 0 ? void 0 : orgForm.rollupCurrency) !== null && _a !== void 0 ? _a : (_b = orgData.data) === null || _b === void 0 ? void 0 : _b.rollupCurrency) !== null && _c !== void 0 ? _c : 'USD').toUpperCase();
  var rollupCurrencyOptionsList = useRollupCurrencyOptions(rollupForAvailable);
  var rollupCurrencyOptions = useMemo(function () {
    return rollupCurrencyOptionsList.map(function (c) {
      return c.id;
    });
  }, [rollupCurrencyOptionsList]);
  // Codes added via "Other..." this session, kept supported until a location save makes the
  // backend's usage-derived customCurrencies report them on its own. This must NOT be backed by
  // orgForm.rates (mere usage) -- see handleAddCustomCurrency: a rollup-currency change wipes all
  // rate rows, so a currency a location still uses could otherwise read as "supported" with no
  // rate behind it, passing beforeNext but then failing finalizeVersion with no way back.
  var _y = useState([]),
    pendingCustomCodes = _y[0],
    setPendingCustomCodes = _y[1];
  var _z = useRollupAvailableCurrencies(rollupForAvailable, {
      configVersionId: configVersionId,
      extraSupportedCodes: pendingCustomCodes
    }),
    availableCurrencyCodes = _z.availableCodes,
    customCurrencyCodes = _z.customCodes,
    availableLocationOptions = _z.options,
    availableCurrenciesRequesting = _z.requesting,
    refetchAvailableCurrencies = _z.refetch;
  var _0 = useState(false),
    customCurrencyDialogOpen = _0[0],
    setCustomCurrencyDialogOpen = _0[1];
  var _1 = useLocationFinancialsAPI(selectedLocationId),
    locationData = _1[0],
    fetchLocationFinancials = _1[1];
  var _2 = useState({}),
    formMap = _2[0],
    setFormMap = _2[1];
  var _3 = useState(null),
    globalError = _3[0],
    setGlobalError = _3[1];
  var _4 = useState(false),
    showIncompleteRowFieldErrors = _4[0],
    setShowIncompleteRowFieldErrors = _4[1];
  var _5 = useState(false),
    clearFinancialsConfirmOpen = _5[0],
    setClearFinancialsConfirmOpen = _5[1];
  var locationFinancialsBaselineRef = useRef({});
  var _6 = useState(0),
    copyDropdownKey = _6[0],
    setCopyDropdownKey = _6[1];
  var _7 = useCopyFinancialsFromAPI(selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : 0),
    copyFromData = _7[0],
    doCopyFrom = _7[1],
    clearCopyFromData = _7[2];
  var _8 = useFinancialsStatusAPI(configVersionId),
    statusData = _8[0],
    fetchStatus = _8[1];
  var configuredLocationIds = useMemo(function () {
    var ids = new Set();
    if (statusData.data) {
      for (var _i = 0, _a = statusData.data; _i < _a.length; _i++) {
        var item = _a[_i];
        if (item.hasConfig) ids.add(item.locationId);
      }
    }
    return ids;
  }, [statusData.data]);
  useEffect(function () {
    if (configVersionId) {
      fetchLocations();
      fetchOrgFinancials();
      fetchStatus();
    }
  }, [configVersionId, fetchLocations, fetchOrgFinancials, fetchStatus]);
  useEffect(function () {
    if (selectedLocationId) {
      fetchLocationFinancials();
    }
  }, [selectedLocationId, fetchLocationFinancials]);
  useEffect(function () {
    if (conversionOpen && configVersionId) {
      fetchProviderRates();
    }
  }, [conversionOpen, configVersionId, fetchProviderRates]);
  useEffect(function () {
    var data = orgData.data;
    if (!data) return;
    setOrgForm(function (prev) {
      if (prev === null || prev === void 0 ? void 0 : prev.isDirty) return prev;
      return mapOrgToForm(data);
    });
  }, [orgData.data]);
  useEffect(function () {
    var data = locationData.data;
    if (!selectedLocationId || !data) return;
    setFormMap(function (prev) {
      var _a;
      var _b;
      if ((_b = prev[selectedLocationId]) === null || _b === void 0 ? void 0 : _b.isDirty) return prev;
      var mapped = mapLocationToForm(data);
      locationFinancialsBaselineRef.current[selectedLocationId] = toBaseline(mapped);
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = mapped, _a));
    });
  }, [locationData.data, selectedLocationId]);
  var currentForm = selectedLocationId == null ? null : (_d = formMap[selectedLocationId]) !== null && _d !== void 0 ? _d : null;
  var locationCurrencyOptions = useMemo(function () {
    return __spreadArray(__spreadArray([], withCurrentCurrencyOption(availableLocationOptions, currentForm === null || currentForm === void 0 ? void 0 : currentForm.currencyCode).map(function (c) {
      return c.id;
    }), true), [OTHER_CURRENCY_ID], false);
  }, [availableLocationOptions, currentForm === null || currentForm === void 0 ? void 0 : currentForm.currencyCode]);
  var currentCurrencyUnsupported = Boolean((currentForm === null || currentForm === void 0 ? void 0 : currentForm.currencyCode) && availableCurrencyCodes && !isCurrencySupported(currentForm.currencyCode, availableCurrencyCodes, customCurrencyCodes));
  var hasUnsupportedLocationCurrencies = useMemo(function () {
    var _a;
    if (!availableCurrencyCodes) return false;
    var codes = new Set();
    for (var _i = 0, _b = Object.values(formMap); _i < _b.length; _i++) {
      var form = _b[_i];
      if (form.currencyCode) codes.add(form.currencyCode.toUpperCase());
    }
    for (var _c = 0, _d = (_a = orgForm === null || orgForm === void 0 ? void 0 : orgForm.rates) !== null && _a !== void 0 ? _a : []; _c < _d.length; _c++) {
      var rate = _d[_c];
      if (rate.currencyCode) codes.add(rate.currencyCode.toUpperCase());
    }
    return Array.from(codes).some(function (code) {
      return !isCurrencySupported(code, availableCurrencyCodes, customCurrencyCodes);
    });
  }, [availableCurrencyCodes, customCurrencyCodes, formMap, orgForm === null || orgForm === void 0 ? void 0 : orgForm.rates]);
  useEffect(function () {
    if (currentForm && !hasIncompleteWageRow(currentForm)) {
      setShowIncompleteRowFieldErrors(false);
    }
  }, [currentForm]);
  var handleOrgRollupChange = function (next) {
    if (next === void 0) {
      next = 'USD';
    }
    if ((orgForm === null || orgForm === void 0 ? void 0 : orgForm.rollupCurrency) === next) return;
    setPendingRollup(next);
  };
  var handleFormChange = useCallback(function (updater) {
    if (!selectedLocationId) return;
    setFormMap(function (prev) {
      var _a;
      var _b;
      var current = (_b = prev[selectedLocationId]) !== null && _b !== void 0 ? _b : {
        currencyCode: 'USD',
        overtimePercent: '',
        premiumMultiplier: '',
        roles: [],
        isDirty: false
      };
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = updater(current), _a));
    });
  }, [selectedLocationId]);
  var handleRoleWageTypeChange = useCallback(function (idx, val) {
    handleFormChange(function (f) {
      return updateRoleAtIndex(f, idx, {
        wageType: val,
        amount: ''
      });
    });
  }, [handleFormChange]);
  var handleRoleAmountChange = useCallback(function (idx, v) {
    handleFormChange(function (f) {
      return updateRoleAtIndex(f, idx, {
        amount: v == null ? '' : String(v)
      });
    });
  }, [handleFormChange]);
  var handleRoleLoadFactorChange = useCallback(function (idx, v) {
    handleFormChange(function (f) {
      return updateRoleAtIndex(f, idx, {
        loadFactor: v == null ? '' : String(v)
      });
    });
  }, [handleFormChange]);
  var handleOvertimePercentChange = useCallback(function (v) {
    handleFormChange(function (f) {
      return __assign(__assign({}, f), {
        overtimePercent: v == null ? '' : String(v),
        isDirty: true
      });
    });
  }, [handleFormChange]);
  var handlePremiumMultiplierChange = useCallback(function (v) {
    handleFormChange(function (f) {
      return __assign(__assign({}, f), {
        premiumMultiplier: v == null ? '' : String(v),
        isDirty: true
      });
    });
  }, [handleFormChange]);
  var wageTypeHourlyLabel = useMemo(function () {
    return String(t('table.hourly', {
      defaultValue: 'Hourly'
    }));
  }, [t]);
  var wageTypeAnnualLabel = useMemo(function () {
    return String(t('table.annual', {
      defaultValue: 'Annual Salary'
    }));
  }, [t]);
  var handleConversionModalSave = useCallback(function (rows) {
    setOrgForm(function (prev) {
      return mergeConversionSaveRowsIntoOrgForm(prev, rows);
    });
  }, []);
  var handleAddCustomCurrency = useCallback(function (_a) {
    var currencyCode = _a.currencyCode,
      corporateOverrideRate = _a.corporateOverrideRate;
    return __awaiter(void 0, void 0, void 0, function () {
      var nextOrgForm, _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            nextOrgForm = mergeCustomCurrencyIntoOrgForm(orgForm, currencyCode, corporateOverrideRate);
            if (!nextOrgForm) {
              setGlobalError(String(t('errors.saveFailed', {
                defaultValue: 'Failed to save financial configuration. Please try again.'
              })));
              return [2 /*return*/];
            }
            // Seed before the save resolves: the backend's customCurrencies is usage-derived, so a
            // just-added code won't appear there (or in orgData.rates) until a location save lands.
            // Without this, the code is unsupported for the whole window between here and that save.
            setPendingCustomCodes(function (prev) {
              return prev.includes(currencyCode) ? prev : __spreadArray(__spreadArray([], prev, true), [currencyCode], false);
            });
            setOrgForm(nextOrgForm);
            _c.label = 1;
          case 1:
            _c.trys.push([1, 3,, 4]);
            // Persist the rate synchronously so the location save (triggered next) sees a manual
            // rate row for this brand-new code instead of failing unsupportedLocationCurrency.
            return [4 /*yield*/, persistDirtyOrgFormSnapshot(configVersionId, nextOrgForm)];
          case 2:
            // Persist the rate synchronously so the location save (triggered next) sees a manual
            // rate row for this brand-new code instead of failing unsupportedLocationCurrency.
            _c.sent();
            setOrgForm(function (prev) {
              return prev === nextOrgForm ? __assign(__assign({}, prev), {
                isDirty: false
              }) : prev;
            });
            fetchOrgFinancials();
            refetchAvailableCurrencies();
            return [3 /*break*/, 4];
          case 3:
            _b = _c.sent();
            setGlobalError(String(t('errors.saveFailed', {
              defaultValue: 'Failed to save financial configuration. Please try again.'
            })));
            return [2 /*return*/];
          case 4:
            handleFormChange(function (f) {
              return __assign(__assign({}, f), {
                currencyCode: currencyCode,
                isDirty: true
              });
            });
            return [2 /*return*/];
        }
      });
    });
  }, [orgForm, configVersionId, fetchOrgFinancials, refetchAvailableCurrencies, handleFormChange, t]);
  var handleCopyFrom = function (sourceLocationId) {
    if (!selectedLocationId) return;
    setGlobalError(null);
    setCopyDropdownKey(function (k) {
      return k + 1;
    });
    doCopyFrom({
      sourceLocationId: sourceLocationId
    });
  };
  useEffect(function () {
    var copied = copyFromData.data;
    if (!selectedLocationId || !copied) return;
    handleFormChange(function () {
      return mapLocationToForm(copied);
    });
    clearCopyFromData();
  }, [copyFromData.data, selectedLocationId, handleFormChange, clearCopyFromData]);
  var handleClearLocation = function () {
    handleFormChange(function (f) {
      return __assign(__assign({}, f), {
        overtimePercent: '',
        premiumMultiplier: '',
        roles: f.roles.map(function (r) {
          return __assign(__assign({}, r), {
            wageType: 'annual_salary',
            amount: '',
            loadFactor: ''
          });
        }),
        isDirty: true
      });
    });
  };
  var getLocationStatus = useCallback(function (id) {
    var form = formMap[id];
    if (form) {
      var isComplete = toNumberOrNull(form.overtimePercent) !== null && toNumberOrNull(form.premiumMultiplier) !== null && form.roles.some(function (r) {
        return isRoleRowComplete(r);
      }) && !hasIncompleteWageRow(form);
      return isComplete ? 'ok' : 'incomplete';
    }
    return configuredLocationIds.has(id) ? 'ok' : 'incomplete';
  }, [formMap, configuredLocationIds]);
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var orgFormRef = useRef(orgForm);
  useEffect(function () {
    orgFormRef.current = orgForm;
  }, [orgForm]);
  var allLocationsRef = useRef(allLocations);
  useEffect(function () {
    allLocationsRef.current = allLocations;
  }, [allLocations]);
  var availableCurrencyCodesRef = useRef(availableCurrencyCodes);
  useEffect(function () {
    availableCurrencyCodesRef.current = availableCurrencyCodes;
  }, [availableCurrencyCodes]);
  var customCurrencyCodesRef = useRef(customCurrencyCodes);
  useEffect(function () {
    customCurrencyCodesRef.current = customCurrencyCodes;
  }, [customCurrencyCodes]);
  var selectedLocationIdRef = useRef(selectedLocationId);
  useEffect(function () {
    selectedLocationIdRef.current = selectedLocationId;
  }, [selectedLocationId]);
  var fetchOrgFinancialsRef = useRef(fetchOrgFinancials);
  useEffect(function () {
    fetchOrgFinancialsRef.current = fetchOrgFinancials;
  }, [fetchOrgFinancials]);
  var refetchAvailableCurrenciesRef = useRef(refetchAvailableCurrencies);
  useEffect(function () {
    refetchAvailableCurrenciesRef.current = refetchAvailableCurrencies;
  }, [refetchAvailableCurrencies]);
  var doOrgSave = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var o, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);
            setGlobalError(null);
            o = orgFormRef.current;
            if (!(o === null || o === void 0 ? void 0 : o.isDirty)) return [2 /*return*/];
            return [4 /*yield*/, persistDirtyOrgFormSnapshot(configVersionId, o)];
          case 1:
            _b.sent();
            setOrgForm(function (prev) {
              return prev ? __assign(__assign({}, prev), {
                isDirty: false
              }) : null;
            });
            fetchOrgFinancialsRef.current();
            refetchAvailableCurrenciesRef.current();
            return [3 /*break*/, 3];
          case 2:
            _a = _b.sent();
            setGlobalError(String(t('errors.saveFailed', {
              defaultValue: 'Failed to save financial configuration. Please try again.'
            })));
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }, [t, configVersionId]);
  var scheduleDebouncedOrgSave = useMemo(function () {
    return debounce(function () {
      void doOrgSave();
    }, 500);
  }, [doOrgSave]);
  var doLocationSave = useCallback(function (locationId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var form, plan, res, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);
            setGlobalError(null);
            form = formMapRef.current[locationId];
            if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return [2 /*return*/];
            plan = planLocationFinancialSave(form, locationId, locationFinancialsBaselineRef.current);
            if (plan.kind === 'invalid') return [2 /*return*/];
            return [4 /*yield*/, persistDirtyLocationSnapshot(locationId, form, locationFinancialsBaselineRef.current, setFormMap)];
          case 1:
            res = _b.sent();
            if (res.ok && res.saved) {
              fetchOrgFinancialsRef.current();
              refetchAvailableCurrenciesRef.current();
            }
            return [3 /*break*/, 3];
          case 2:
            _a = _b.sent();
            setGlobalError(String(t('errors.saveFailed', {
              defaultValue: 'Failed to save financial configuration. Please try again.'
            })));
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }, [t]);
  var scheduleDebouncedLocationSave = useMemo(function () {
    return debounce(function (locationId) {
      void doLocationSave(locationId);
    }, 500);
  }, [doLocationSave]);
  useEffect(function () {
    return function () {
      scheduleDebouncedOrgSave.cancel();
      scheduleDebouncedLocationSave.cancel();
    };
  }, [scheduleDebouncedOrgSave, scheduleDebouncedLocationSave]);
  /** Org roll-up / conversion rates save without wage-row checks. Location auto-save runs only when rows are not incomplete (same as switching location). */
  useEffect(function () {
    if (!(orgForm === null || orgForm === void 0 ? void 0 : orgForm.isDirty)) return;
    scheduleDebouncedOrgSave();
  }, [orgForm === null || orgForm === void 0 ? void 0 : orgForm.isDirty, orgForm === null || orgForm === void 0 ? void 0 : orgForm.rollupCurrency, orgForm === null || orgForm === void 0 ? void 0 : orgForm.rates, scheduleDebouncedOrgSave]);
  useEffect(function () {
    var id = selectedLocationId;
    if (id == null) return;
    var form = formMap[id];
    if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return;
    var plan = planLocationFinancialSave(form, id, locationFinancialsBaselineRef.current);
    if (plan.kind === 'invalid') return;
    scheduleDebouncedLocationSave(id);
  }, [formMap, selectedLocationId, scheduleDebouncedLocationSave]);
  var persistCurrentFinancials = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var orgF, id, fm, didSave, form, res, _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            scheduleDebouncedOrgSave.cancel();
            scheduleDebouncedLocationSave.cancel();
            setGlobalError(null);
            orgF = orgFormRef.current;
            id = selectedLocationIdRef.current;
            fm = formMapRef.current;
            _b.label = 1;
          case 1:
            _b.trys.push([1, 6,, 7]);
            didSave = false;
            if (!(orgF === null || orgF === void 0 ? void 0 : orgF.isDirty)) return [3 /*break*/, 3];
            return [4 /*yield*/, persistDirtyOrgFormSnapshot(configVersionId, orgF)];
          case 2:
            _b.sent();
            setOrgForm(function (prev) {
              return prev ? __assign(__assign({}, prev), {
                isDirty: false
              }) : null;
            });
            didSave = true;
            _b.label = 3;
          case 3:
            if (!(id != null)) return [3 /*break*/, 5];
            form = fm[id];
            if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return [3 /*break*/, 5];
            return [4 /*yield*/, persistDirtyLocationSnapshot(id, form, locationFinancialsBaselineRef.current, setFormMap)];
          case 4:
            res = _b.sent();
            if (!res.ok) {
              setShowIncompleteRowFieldErrors(true);
              return [2 /*return*/, false];
            }
            if (res.saved) didSave = true;
            _b.label = 5;
          case 5:
            if (didSave) {
              fetchOrgFinancialsRef.current();
              refetchAvailableCurrenciesRef.current();
            }
            return [2 /*return*/, true];
          case 6:
            _a = _b.sent();
            setGlobalError(String(t('errors.saveFailed', {
              defaultValue: 'Failed to save financial configuration. Please try again.'
            })));
            return [2 /*return*/, false];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  }, [t, scheduleDebouncedOrgSave, scheduleDebouncedLocationSave, configVersionId]);
  var onSelectLocation = usePersistingLocationSelect({
    selectedLocationId: selectedLocationId,
    setSelectedLocationId: setSelectedLocationId,
    persistCurrent: persistCurrentFinancials
  }).onSelectLocation;
  var rowFieldErrors = useMemo(function () {
    if (!currentForm) return [];
    return currentForm.roles.map(function (r) {
      return getStartedRowFieldErrors(r, showIncompleteRowFieldErrors);
    });
  }, [currentForm, showIncompleteRowFieldErrors]);
  var showHeaderRequiredMarkers = showIncompleteRowFieldErrors && currentForm != null && hasIncompleteWageRow(currentForm);
  useEffect(function () {
    var beforeNextFn = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var orgF, locations, fm, available, custom, _i, locations_1, loc, form, _a, _b, rate, clearedDirtyIds_1, _c, locations_2, loc, form, plan, baseline, _d;
        var _e;
        return __generator(this, function (_f) {
          switch (_f.label) {
            case 0:
              scheduleDebouncedOrgSave.cancel();
              scheduleDebouncedLocationSave.cancel();
              setGlobalError(null);
              orgF = orgFormRef.current;
              locations = allLocationsRef.current;
              fm = formMapRef.current;
              available = availableCurrencyCodesRef.current;
              custom = customCurrencyCodesRef.current;
              if (available) {
                for (_i = 0, locations_1 = locations; _i < locations_1.length; _i++) {
                  loc = locations_1[_i];
                  form = fm[loc.id];
                  if ((form === null || form === void 0 ? void 0 : form.currencyCode) && !isCurrencySupported(form.currencyCode, available, custom)) {
                    setSelectedLocationId(loc.id);
                    setGlobalError(String(t('errors.unsupportedLocationCurrency', {
                      defaultValue: 'One or more location currencies are not supported for the selected roll-up currency. Please change the highlighted currencies.',
                      currency: form.currencyCode
                    })));
                    return [2 /*return*/, false];
                  }
                }
                for (_a = 0, _b = (_e = orgF === null || orgF === void 0 ? void 0 : orgF.rates) !== null && _e !== void 0 ? _e : []; _a < _b.length; _a++) {
                  rate = _b[_a];
                  if (rate.currencyCode && !isCurrencySupported(rate.currencyCode, available, custom)) {
                    setGlobalError(String(t('errors.unsupportedLocationCurrency', {
                      defaultValue: 'One or more location currencies are not supported for the selected roll-up currency. Please change the highlighted currencies.',
                      currency: rate.currencyCode
                    })));
                    return [2 /*return*/, false];
                  }
                }
              }
              _f.label = 1;
            case 1:
              _f.trys.push([1, 8,, 9]);
              if (!(orgF === null || orgF === void 0 ? void 0 : orgF.isDirty)) return [3 /*break*/, 3];
              return [4 /*yield*/, persistDirtyOrgFormSnapshot(configVersionId, orgF)];
            case 2:
              _f.sent();
              setOrgForm(function (prev) {
                return prev ? __assign(__assign({}, prev), {
                  isDirty: false
                }) : null;
              });
              _f.label = 3;
            case 3:
              clearedDirtyIds_1 = [];
              _c = 0, locations_2 = locations;
              _f.label = 4;
            case 4:
              if (!(_c < locations_2.length)) return [3 /*break*/, 7];
              loc = locations_2[_c];
              form = fm[loc.id];
              if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return [3 /*break*/, 6];
              plan = planLocationFinancialSave(form, loc.id, locationFinancialsBaselineRef.current);
              if (plan.kind === 'invalid') {
                setSelectedLocationId(loc.id);
                setShowIncompleteRowFieldErrors(true);
                return [2 /*return*/, false];
              }
              if (plan.kind === 'draft') {
                baseline = locationFinancialsBaselineRef.current[loc.id];
                if (baseline && baselinesEqual(toBaseline(form), baseline)) {
                  clearedDirtyIds_1.push(loc.id);
                }
                return [3 /*break*/, 6];
              }
              return [4 /*yield*/, saveLocationFinancials(loc.id, plan.payload)];
            case 5:
              _f.sent();
              locationFinancialsBaselineRef.current[loc.id] = toBaseline(__assign(__assign({}, form), {
                isDirty: false
              }));
              clearedDirtyIds_1.push(loc.id);
              _f.label = 6;
            case 6:
              _c++;
              return [3 /*break*/, 4];
            case 7:
              if (clearedDirtyIds_1.length > 0) {
                setFormMap(function (prev) {
                  var _a;
                  var next = __assign({}, prev);
                  for (var _i = 0, clearedDirtyIds_2 = clearedDirtyIds_1; _i < clearedDirtyIds_2.length; _i++) {
                    var lid = clearedDirtyIds_2[_i];
                    var cur = next[lid];
                    if (cur) next = __assign(__assign({}, next), (_a = {}, _a[lid] = __assign(__assign({}, cur), {
                      isDirty: false
                    }), _a));
                  }
                  return next;
                });
              }
              return [2 /*return*/, true];
            case 8:
              _d = _f.sent();
              setGlobalError(String(t('errors.saveFailed', {
                defaultValue: 'Failed to save financial configuration. Please try again.'
              })));
              return [2 /*return*/, false];
            case 9:
              return [2 /*return*/];
          }
        });
      });
    };
    setBeforeNext(beforeNextFn);
    return function () {
      return setBeforeNext(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setBeforeNext, scheduleDebouncedOrgSave, scheduleDebouncedLocationSave]);
  var hasMadeChangesRef = useRef(false);
  var isCurrentlyDirty = Boolean((orgForm === null || orgForm === void 0 ? void 0 : orgForm.isDirty) || Object.values(formMap).some(function (form) {
    return form.isDirty;
  }));
  useEffect(function () {
    if (isCurrentlyDirty) {
      hasMadeChangesRef.current = true;
    }
  }, [isCurrentlyDirty]);
  var checkIsDirty = useCallback(function () {
    var _a;
    var isDirty = Boolean(((_a = orgFormRef.current) === null || _a === void 0 ? void 0 : _a.isDirty) || Object.values(formMapRef.current).some(function (form) {
      return form.isDirty;
    }));
    return hasMadeChangesRef.current || isDirty;
  }, []);
  useOrgConfigDirtyRegister(checkIsDirty);
  var isLoading = locationsData.requesting || orgData.requesting || locationData.requesting;
  var conversionRatesAvailable = ((_f = (_e = orgForm === null || orgForm === void 0 ? void 0 : orgForm.rates) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0;
  return _jsxs(_Fragment, {
    children: [headerRightEl && createPortal(_jsxs(Stack, __assign({
      direction: "row",
      alignItems: "center",
      spacing: 2,
      flexWrap: "wrap",
      useFlexGap: true,
      sx: {
        ml: 'auto',
        justifyContent: 'flex-end'
      }
    }, {
      children: [_jsx(Typography, __assign({
        noWrap: true
      }, {
        children: t('rollup.label', {
          defaultValue: 'Roll-up reporting'
        })
      })), _jsx(Autocomplete, {
        size: "small",
        options: rollupCurrencyOptions,
        value: (_g = orgForm === null || orgForm === void 0 ? void 0 : orgForm.rollupCurrency) !== null && _g !== void 0 ? _g : 'USD',
        onChange: function (v) {
          if (v) handleOrgRollupChange(v);
        },
        disabled: isReadOnly,
        sx: {
          width: 200,
          maxWidth: 'min(200px, 100%)'
        }
      }), _jsx(Link, __assign({
        component: "button",
        type: "button",
        "aria-disabled": !conversionRatesAvailable,
        onClick: conversionRatesAvailable ? function () {
          return setConversionOpen(true);
        } : undefined,
        sx: __assign({
          whiteSpace: 'nowrap'
        }, conversionRatesAvailable ? {} : {
          color: 'text.disabled',
          pointerEvents: 'none',
          cursor: 'default',
          textDecoration: 'none'
        })
      }, {
        children: t('conversion.link', {
          defaultValue: 'Currency conversion'
        })
      }))]
    })), headerRightEl), _jsx(CurrencyConversionModal, {
      open: conversionOpen,
      rollupCurrency: ((_h = orgForm === null || orgForm === void 0 ? void 0 : orgForm.rollupCurrency) !== null && _h !== void 0 ? _h : 'USD').toUpperCase(),
      rates: ((_j = orgForm === null || orgForm === void 0 ? void 0 : orgForm.rates) !== null && _j !== void 0 ? _j : []).map(function (r) {
        return {
          currencyCode: r.currencyCode,
          corporateOverrideRate: r.corporateOverrideRate || null,
          lastUpdated: r.lastUpdated,
          provenance: r.provenance || null,
          providerTimestamp: r.providerTimestamp || null
        };
      }),
      providerRates: (_l = (_k = providerRatesData.data) === null || _k === void 0 ? void 0 : _k.rates) !== null && _l !== void 0 ? _l : [],
      providerRatesLoading: providerRatesData.requesting,
      providerRatesError: Boolean(providerRatesData.error),
      providerRatesLastUpdated: (_o = (_m = providerRatesData.data) === null || _m === void 0 ? void 0 : _m.providerTimestamp) !== null && _o !== void 0 ? _o : null,
      onClose: function () {
        return setConversionOpen(false);
      },
      onSave: handleConversionModalSave,
      readOnly: isReadOnly
    }), _jsx(AddCustomCurrencyDialog, {
      open: customCurrencyDialogOpen,
      rollupCurrency: rollupForAvailable,
      existingCodes: locationCurrencyOptions,
      onClose: function () {
        return setCustomCurrencyDialogOpen(false);
      },
      onSave: handleAddCustomCurrency
    }), globalError && _jsx(Alert, __assign({
      severity: "error",
      sx: {
        mb: 2
      },
      onClose: function () {
        return setGlobalError(null);
      }
    }, {
      children: globalError
    })), !globalError && (currentCurrencyUnsupported || hasUnsupportedLocationCurrencies) && _jsx(Alert, __assign({
      severity: "error",
      sx: {
        mb: 2
      }
    }, {
      children: t('errors.unsupportedLocationCurrency', {
        defaultValue: 'One or more location currencies are not supported for the selected roll-up currency. Please change the highlighted currencies.',
        currency: currentForm === null || currentForm === void 0 ? void 0 : currentForm.currencyCode
      })
    })), _jsx(OrgConfigStepContainer, __assign({
      leftContent: _jsx(LocationListPanel, {
        allLocations: allLocations,
        selectedLocationId: selectedLocationId,
        onSelectLocation: onSelectLocation,
        getLocationStatus: getLocationStatus,
        title: t('locations.title', {
          defaultValue: 'Site locations'
        }),
        description: t('locations.description', {
          defaultValue: 'Select a location to view/edit data.'
        })
      })
    }, {
      children: !selectedLocation || !currentForm ? _jsx(FallbackComponent, __assign({
        requesting: isLoading
      }, {
        children: _jsx(Box, __assign({
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 260
          }
        }, {
          children: _jsx(Typography, __assign({
            color: "text.secondary"
          }, {
            children: t('selectLocation', {
              defaultValue: 'Select a location to configure its financials.'
            })
          }))
        }))
      })) : _jsxs(StepContentPanel, __assign({
        title: t('title', {
          defaultValue: 'Financials'
        }),
        description: t('subtitle', {
          defaultValue: 'Add the salaries/wages for both agent and support staff roles. Indicate the currency applicable for each site location.'
        }),
        action: _jsx(CopyFromLocationDropdown, {
          locations: allLocations,
          currentLocationId: selectedLocation.id,
          onCopy: handleCopyFrom,
          onClear: function () {
            return setClearFinancialsConfirmOpen(true);
          },
          disabled: isReadOnly
        }, copyDropdownKey)
      }, {
        children: [_jsxs(Box, __assign({
          sx: {
            display: 'grid',
            columnGap: function (theme) {
              return theme.spacing(3);
            },
            rowGap: function (theme) {
              return theme.spacing(2);
            },
            /** Side-by-side currency only from `md` so overtime + premium keep full width below (avoids premium wrapping beside currency). */
            gridTemplateColumns: {
              xs: 'minmax(0, 1fr)',
              md: 'minmax(0, 1fr) 200px'
            },
            gridTemplateAreas: {
              xs: '"currency" "fields"',
              md: '"fields currency"'
            },
            alignItems: 'start'
          }
        }, {
          children: [_jsxs(Stack, __assign({
            direction: "row",
            spacing: 3,
            flexWrap: {
              xs: 'wrap',
              md: 'nowrap'
            },
            useFlexGap: true,
            sx: {
              gridArea: 'fields',
              minWidth: 0,
              width: '100%'
            }
          }, {
            children: [_jsx(UnControlledFormField, __assign({
              label: t('location.overtimePercent', {
                defaultValue: 'Overtime costs'
              }),
              unitLabel: "%",
              sx: {
                minWidth: {
                  xs: 160,
                  md: 220
                },
                flex: {
                  md: '1 1 0'
                }
              }
            }, {
              children: _jsx(NumberInput, {
                min: 0,
                max: 100,
                decimal: 2,
                value: currentForm.overtimePercent,
                onChange: handleOvertimePercentChange,
                disabled: isReadOnly
              })
            })), _jsx(UnControlledFormField, __assign({
              label: t('location.premiumMultiplier', {
                defaultValue: 'Overtime premium multiplier'
              }),
              sx: {
                minWidth: {
                  xs: 180,
                  md: 260
                },
                flex: {
                  md: '1 1 0'
                }
              }
            }, {
              children: _jsx(NumberInput, {
                min: 0,
                max: 5,
                decimal: 2,
                value: currentForm.premiumMultiplier,
                onChange: handlePremiumMultiplierChange,
                disabled: isReadOnly
              })
            }))]
          })), _jsx(UnControlledFormField, __assign({
            label: t('location.currency', {
              defaultValue: 'Currency'
            }),
            sx: {
              gridArea: 'currency',
              width: 200,
              maxWidth: 'min(200px, 100%)',
              justifySelf: {
                xs: 'end',
                md: 'stretch'
              }
            }
          }, {
            children: _jsx(Autocomplete, {
              size: "small",
              fullWidth: true,
              options: locationCurrencyOptions,
              getOptionLabel: function (o) {
                return o === OTHER_CURRENCY_ID ? String(t('location.otherCurrency', {
                  defaultValue: 'Other...'
                })) : o;
              },
              value: currentForm.currencyCode,
              onChange: function (v) {
                if (v === OTHER_CURRENCY_ID) {
                  setCustomCurrencyDialogOpen(true);
                  return;
                }
                handleFormChange(function (f) {
                  return __assign(__assign({}, f), {
                    currencyCode: v !== null && v !== void 0 ? v : '',
                    isDirty: true
                  });
                });
              },
              disabled: isReadOnly || availableCurrenciesRequesting,
              error: currentCurrencyUnsupported,
              helperText: currentCurrencyUnsupported ? String(t('errors.unsupportedCurrencySelected', {
                defaultValue: '{{currency}} cannot be converted to {{rollup}}. Please select another currency.',
                currency: currentForm.currencyCode,
                rollup: rollupForAvailable
              })) : undefined
            })
          }))]
        })), _jsx(WizardTable, __assign({
          headers: _jsxs(_Fragment, {
            children: [_jsx(TableCell, {
              children: t('table.role', {
                defaultValue: 'Role'
              })
            }), _jsxs(TableCell, {
              children: [t('table.wageType', {
                defaultValue: 'Wage type'
              }), showHeaderRequiredMarkers ? ' *' : '']
            }), _jsxs(TableCell, __assign({
              align: "center"
            }, {
              children: [t('table.amount', {
                defaultValue: 'Amount'
              }), showHeaderRequiredMarkers ? ' *' : '']
            })), _jsx(TableCell, __assign({
              align: "center"
            }, {
              children: t('table.loadFactor', {
                defaultValue: 'Load Factor % (optional)'
              })
            }))]
          })
        }, {
          children: _jsx(TableBody, {
            children: currentForm.roles.map(function (r, idx) {
              var _a, _b, _c, _d;
              return _jsx(FinancialsRoleRow, {
                row: r,
                rowIndex: idx,
                getRoleDisplayName: getRoleDisplayName,
                wageTypeHourlyLabel: wageTypeHourlyLabel,
                wageTypeAnnualLabel: wageTypeAnnualLabel,
                wageTypeError: (_b = (_a = rowFieldErrors[idx]) === null || _a === void 0 ? void 0 : _a.wageType) !== null && _b !== void 0 ? _b : false,
                amountError: (_d = (_c = rowFieldErrors[idx]) === null || _c === void 0 ? void 0 : _c.amount) !== null && _d !== void 0 ? _d : false,
                onWageTypeChange: handleRoleWageTypeChange,
                onAmountChange: handleRoleAmountChange,
                onLoadFactorChange: handleRoleLoadFactorChange,
                disabled: isReadOnly,
                currencyCode: currentForm.currencyCode
              }, r.roleName);
            })
          })
        }))]
      }))
    })), _jsx(ConfirmDialog, {
      open: clearFinancialsConfirmOpen,
      onClose: function () {
        return setClearFinancialsConfirmOpen(false);
      },
      title: t('clearDataConfirmTitle', {
        defaultValue: 'Clear financial data?'
      }),
      message: t('clearDataConfirmMessage', {
        defaultValue: 'Are you sure you want to clear all financial data for this location?'
      }),
      onConfirm: function () {
        handleClearLocation();
        setClearFinancialsConfirmOpen(false);
      }
    }), _jsx(ConfirmDialog, {
      open: pendingRollup !== null,
      onClose: function () {
        return setPendingRollup(null);
      },
      title: t('rollupChangeConfirmTitle', {
        defaultValue: 'Change roll-up currency?'
      }),
      message: t('rollupChangeConfirmMessage', {
        defaultValue: 'Rates in this working version will be cleared/rebuilt. Existing plans are unaffected.'
      }),
      onConfirm: function () {
        if (pendingRollup) {
          setOrgForm(function (prev) {
            if (!prev) return {
              rollupCurrency: pendingRollup,
              rates: [],
              isDirty: true
            };
            return __assign(__assign({}, prev), {
              rollupCurrency: pendingRollup,
              rates: prev.rates.map(function (r) {
                return __assign(__assign({}, r), {
                  corporateOverrideRate: ''
                });
              }),
              isDirty: true
            });
          });
          setPendingRollup(null);
        }
      }
    })]
  });
};